// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1wo0v","row":"Node_row__27vJn","label":"Node_label__1Ud_g","footer":"Node_footer__1j92u"};